// "Pakete gösterge ekle" penceresi kopyası (Katalog · AI ile öner + Seçim paneli) — tek kaynak;
// `KPI_PACKAGES_COPY.add` olarak bağlanır. DR12: yüzeyde HTTP kodu / sınır dili yok.

import { KPI_PACKAGE_SUGGEST_NOTE_MAX } from "@mahir/shared";

export const KPI_PACKAGES_ADD_COPY = {
  title: "Pakete gösterge ekle",
  description: "Seçtikleriniz taslağa eklenir; Kaydet ile pakete yazılır.",
  tabsLabel: "Gösterge kaynağı",
  tabs: { catalog: "Katalog", suggest: "AI ile öner" },
  search: "Ara (ad ya da kod)",
  clearSearch: "Aramayı temizle",
  hideInPackage: "Pakettekileri gizle",
  selectionTitle: "Seçim",
  selectionEmpty: "Henüz gösterge seçilmedi",
  noCategory: "Kategorisiz",
  sourceAi: "AI",
  sourceCatalog: "Katalog",
  autoNote: (n: number): string =>
    `+ ${n} gösterge otomatik eklenecek (formül girdileri ve kırılımlar)`,
  footerNote: "AI önerileri kayıttan önce sizin onayınızla eklenir.",
  cancel: "Vazgeç",
  confirm: (n: number): string => `Taslağa ekle (${n})`,
  remove: (label: string): string => `${label} seçimden çıkar`,
  summary: (n: number): string => `Seçim: ${n} gösterge`,
  suggest: {
    intro:
      "Paketin sektörü, adı, açıklaması ve notunuz ile katalog incelenir; yalnız katalogdaki göstergeler önerilir.",
    noteLabel: "Not (isteğe bağlı)",
    notePlaceholder: "ör. iklim riskine ağırlık ver",
    noteCount: (n: number): string => `${n} / ${KPI_PACKAGE_SUGGEST_NOTE_MAX}`,
    run: "Öner",
    rerun: "Yeniden öner",
    loading: "Katalog inceleniyor…",
    summary: (s: number, a: number, k: number): string =>
      [`${s} öneri`, a ? `${a} otomatik eklenecek` : null, k ? `${k} zaten pakette` : null]
        .filter((x): x is string => x !== null)
        .join(" · "),
    suggestedPill: "önerildi",
    empty: "Bu paket için önerilecek yeni gösterge bulunamadı",
    treeLabel: "Önerilen göstergeler",
  },
} as const;
